import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, MapPinIcon, ShieldCheckIcon, MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { trackLead } from '../utils/metaPixel';
export function Hero() {
  return <header className="relative isolate w-full overflow-hidden bg-abyss" data-id="element-61" data-mp="9ipbpaa4vbzl">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/87dd5680-0bb1-4bcd-8cf4-38d1de0d17bf.jpg" alt="Pescador mexicano sosteniendo una lobina trofeo al amanecer en una presa" className="absolute inset-0 h-full w-full object-cover object-center opacity-55" data-id="element-62" data-mp="4n1ov1j4iux9" />
      <div className="absolute inset-0 bg-abyss/70" aria-hidden="true" data-id="element-63" data-mp="s9q8psrp0xgi" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-abyss to-transparent" aria-hidden="true" data-id="element-64" data-mp="nczvdd79wfys" />

      <div className="relative mx-auto flex min-h-[62vh] max-w-6xl flex-col justify-end px-4 pb-8 pt-14 sm:min-h-[80vh] sm:px-8 sm:pb-20 sm:pt-24" data-id="element-65" data-mp="3czfk1vt6u14g">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-66" data-mp="3j895n7fl21mw">
          <div className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-1 font-cond text-[0.68rem] uppercase tracking-[0.16em] text-chartreuse sm:mb-6 sm:text-sm sm:tracking-[0.2em]" data-id="element-67" data-mp="39al9qe68qo35">
            <span className="flex items-center gap-1.5" data-id="element-68" data-mp="30i18r72h87f5">
              <MapPinIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-69" data-mp="30ggdff8c8kg8" />
              Hecho a mano en México
            </span>
            <span className="hidden h-4 w-px bg-bone/30 sm:block" aria-hidden="true" data-id="element-70" data-mp="2qjv80ssep7bv" />
            <span className="text-bone/70" data-id="element-71" data-mp="2qhqx3qw3b823">El Salto · Comedero · Aguamilpa</span>
          </div>

          <h1 className="font-display text-[1.9rem] uppercase leading-[0.95] text-bone sm:text-6xl sm:leading-[0.92] lg:text-[5rem]" data-id="element-72" data-mp="2vgu25bc2lea2">
            La lobina de tu vida no está esperando
            <span className="block text-chartreuse" data-id="element-73" data-mp="2ljz1alsbr1sm">
              otro pedazo de plástico muerto.
            </span>
          </h1>

          <p className="mt-4 max-w-2xl font-body text-[0.95rem] leading-relaxed text-bone/80 sm:mt-6 sm:text-xl" data-id="element-74" data-mp="nbb9spq0zv12">
            Polímero de alta memoria para que la cola nunca deje de vibrar,
            aroma amasado dentro de la mezcla y colores moldeados a mano en
            México. Movimiento que se siente antes de verse.
          </p>

          <div className="mt-5 flex flex-col items-stretch gap-2.5 sm:mt-9 sm:flex-row sm:items-center sm:gap-4" data-id="element-75" data-mp="1azku1n7lcaq3">
            <div className="flex flex-col gap-2" data-id="element-76" data-mp="162c95ev25sl5">
              <CtaButton size="md" source="hero" className="sm:hidden" data-id="element-77" data-mp="112g89ohnqh9t">
                ¡Quiero pescar más ya!
              </CtaButton>
              <CtaButton source="hero" className="hidden sm:inline-flex" data-id="element-78" data-mp="x0crqlg4smho">
                ¡Quiero pescar más ya!
              </CtaButton>
              <a href="#garantia" className="flex items-center justify-center gap-1.5 font-cond text-xs uppercase tracking-wide text-chartreuse hover:underline sm:justify-start sm:text-sm" data-id="element-79" data-mp="3lqm4435bldx1">
                <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-80" data-mp="21a4txwhwuk6i" />
                Dos salidas o te devolvemos $399
              </a>
            </div>
            
            <div className="flex flex-col gap-2 sm:ml-2" data-id="element-81" data-mp="2686aoarv67et">
              <span className="flex items-center justify-center gap-2 font-cond text-[0.8rem] uppercase tracking-wider text-bone/65 sm:justify-start sm:text-base" data-id="element-82" data-mp="2b1hkmkrz34ay">
                <FlameIcon className="h-4 w-4 text-blood sm:h-5 sm:w-5" aria-hidden="true" data-id="element-83" data-mp="2kynd9xg8j3da" />
                120 packs por corrida y se acaban
              </span>
              <a href="https://wa.me/5212345678900" target="_blank" rel="noopener noreferrer" onClick={() => trackLead('hero-whatsapp')} className="flex items-center justify-center gap-1.5 font-cond text-xs uppercase tracking-wide text-bone/60 hover:text-bone sm:justify-start sm:text-sm" data-id="element-84" data-mp="2oye7kb4z01mk">
                <MessageCircleIcon className="h-3.5 w-3.5" data-id="element-85" data-mp="49t5s073b8vi" />
                Tengo dudas, pregúntame
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}